// extracted by mini-css-extract-plugin
export default {"layout":"SectionLayout_layout__8N9jJ"};